import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const SaveIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 24 24"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <g clip-path="url(#clip0_3169_137309)">
                <path
                    d="M20.25 1H7.53715C6.81277 1.00371 6.11876 1.29147 5.60429 1.80143L1.80143 5.60429C1.5468 5.85755 1.34487 6.15877 1.20731 6.49052C1.06976 6.82228 0.999296 7.178 1.00001 7.53714V20.25C1.00413 20.9781 1.29519 21.6752 1.81002 22.19C2.32485 22.7048 3.02193 22.9959 3.75001 23H20.25C20.9781 22.9959 21.6752 22.7048 22.19 22.19C22.7048 21.6752 22.9959 20.9781 23 20.25V3.75C22.9959 3.02193 22.7048 2.32485 22.19 1.81001C21.6752 1.29518 20.9781 1.00413 20.25 1V1ZM17.5 19.4643C17.4959 19.7756 17.3705 20.073 17.1503 20.2932C16.9302 20.5133 16.6327 20.6388 16.3214 20.6429H7.67858C7.36727 20.6388 7.06985 20.5133 6.8497 20.2932C6.62955 20.073 6.50408 19.7756 6.50001 19.4643V14.75C6.50408 14.4387 6.62955 14.1413 6.8497 13.9211C7.06985 13.701 7.36727 13.5755 7.67858 13.5714H16.3214C16.6327 13.5755 16.9302 13.701 17.1503 13.9211C17.3705 14.1413 17.4959 14.4387 17.5 14.75V19.4643ZM17.5 7.67857C17.4959 7.98988 17.3705 8.2873 17.1503 8.50745C16.9302 8.7276 16.6327 8.85307 16.3214 8.85714H10.0357C9.72441 8.85307 9.42699 8.7276 9.20684 8.50745C8.98669 8.2873 8.86122 7.98988 8.85715 7.67857V4.53571C8.86122 4.2244 8.98669 3.92699 9.20684 3.70684C9.42699 3.48669 9.72441 3.36121 10.0357 3.35714H16.3214C16.6327 3.36121 16.9302 3.48669 17.1503 3.70684C17.3705 3.92699 17.4959 4.2244 17.5 4.53571V7.67857Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_3169_137309">
                    <rect width="22" height="22" fill={color} transform="translate(1 1)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(SaveIcon);
